import { css } from 'lit';

export const style = css`:host{position:absolute;display:none;width:0;height:0;border:0}`;
